var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserRegular(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9688 12.9688H8.03125C4.04453 12.9688 0.8125 16.2008 0.8125 20.1875C0.8125 20.9122 1.40025 21.5 2.125 21.5H17.875C18.5997 21.5 19.1875 20.9122 19.1875 20.1875C19.1875 16.2008 15.9555 12.9688 11.9688 12.9688ZM2.82186 19.5312C3.14588 16.9432 5.35703 14.9375 8.03125 14.9375H11.9688C14.6413 14.9375 16.8537 16.9452 17.1777 19.5312H2.82186ZM10 11C12.8994 11 15.25 8.64939 15.25 5.75C15.25 2.85061 12.8994 0.5 10 0.5C7.10061 0.5 4.75 2.85061 4.75 5.75C4.75 8.6498 7.1002 11 10 11ZM10 2.46875C11.8092 2.46875 13.2812 3.9408 13.2812 5.75C13.2812 7.5592 11.8092 9.03125 10 9.03125C8.1908 9.03125 6.71875 7.55879 6.71875 5.75C6.71875 3.9408 8.19121 2.46875 10 2.46875Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserRegular);
export default __webpack_public_path__ + "static/media/user-regular.901e70192434349d5d66b32adeb83f5b.svg";
export { ForwardRef as ReactComponent };